export const isAuthError = (error: unknown) => {
  if (!error || typeof error !== "object") return false;

  const status = (error as { response?: { status?: number }; status?: number }).response?.status;
  const fallbackStatus = (error as { status?: number }).status;
  const name = (error as { name?: string }).name;

  return (
    status === 401 ||
    status === 403 ||
    fallbackStatus === 401 ||
    fallbackStatus === 403 ||
    name === "AuthorizationError"
  );
};

export const copyTextToClipboard = async (text: string) => {
  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  document.execCommand("copy");
  document.body.removeChild(textArea);
};
